/* ZINKE — mitlaufende Kaufleiste auf dem Handy, 14.09.2026
   geändert 18.09.2026 (Theme 2.5): Leiste steht SOFORT, nicht erst nach dem Scrollen
   geändert 19.09.2026 (Theme 3.0): Schwelle korrigiert, siehe unten

   Auch nach dem Aufraeumen der Abstaende liegt der Bestellbutton auf einer
   Produktseite rund 880 px tief – das Produktbild allein braucht die halbe
   Bildschirmhoehe. Statt Bild und Text weiter zusammenzuquetschen blendet
   sich eine schmale Leiste am unteren Rand ein, sobald der echte Button nicht
   im Bild ist. Preis links, Bestellbutton rechts.

   18.09.2026: Bis hierher kam die Leiste nur, wenn der echte Button nach OBEN
   aus dem Bild gescrollt war. Wer aus einer Anzeige kommt und nicht scrollt,
   sah also nie einen Kaufknopf — 97 TikTok-Besucher, null Warenkoerbe. Jetzt
   steht sie immer dann, wenn der echte Button nicht sichtbar ist, also auch
   beim Laden, solange er noch darunter liegt. Ausverkauft: keine Leiste.

   19.09.2026: Ein Pixel reichte bis hierher als "sichtbar". Auf einem iPhone 13
   (Viewport 664 hoch) liegt der Knopf bei 648 und ragt damit 16 px ins Bild —
   der Beobachter meldete "sichtbar", die Leiste blieb aus, und der Besucher sah
   trotzdem keinen brauchbaren Kaufknopf. Gemessen mit Playwright: iPhone SE 375x553
   zeigte die Leiste, iPhone 13 390x664 nicht, Pixel 7 412x780 brauchte sie nicht.
   Deshalb jetzt: Ziel ist der Knopf selbst statt der ganzen buy-row, und er gilt
   erst als im Bild, wenn er VOLLSTAENDIG und mit 88 px Luft zum unteren Rand
   sichtbar ist (threshold 1 + negativer rootMargin).

   Der Knopf in der Leiste ist kein Nachbau: er traegt das form-Attribut des
   echten Produktformulars und loest damit denselben Absendevorgang aus –
   inklusive Variantenwahl, Menge und der Logik in zinke-addon.js.

   Nur bis 749 px sichtbar (per CSS). Ohne IntersectionObserver passiert
   nichts, die Seite bleibt normal bedienbar.
*/
(() => {
  'use strict';

  let beobachter = null;
  let leiste = null;

  function hoeheSetzen(px) {
    document.documentElement.style.setProperty('--zinke-kaufleiste', px + 'px');
  }

  function leisteBauen() {
    if (leiste) return leiste;
    leiste = document.createElement('div');
    leiste.className = 'kaufleiste';
    leiste.setAttribute('data-kaufleiste', '');

    const preis = document.createElement('span');
    preis.className = 'kaufleiste-preis';
    preis.setAttribute('data-kaufleiste-preis', '');

    const knopf = document.createElement('button');
    knopf.type = 'submit';
    knopf.className = 'button kaufleiste-knopf';
    knopf.setAttribute('data-kaufleiste-knopf', '');

    leiste.appendChild(preis);
    leiste.appendChild(knopf);
    document.body.appendChild(leiste);
    return leiste;
  }

  function aufraeumen() {
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    if (leiste) { leiste.remove(); leiste = null; }
    hoeheSetzen(0);
  }

  function einrichten() {
    const form = document.querySelector('.product-form');
    // NICHT form.id: das Formular hat ein Feld name="id" (Variante), dann
    // liefert form.id dieses Feld statt der ID. Bis 18.09.2026 stand deshalb
    // form="[object HTMLInputElement]" am Knopf und die Leiste legte nichts
    // in den Warenkorb.
    const formId = form ? form.getAttribute('id') : '';
    const echterKnopf = document.querySelector('.buy-row [data-add-button]');
    // Nur auf Produktseiten: auf der Startseite steht ggf. ein Produktblock
    // weiter unten, dort soll die Leiste nicht schon beim Laden erscheinen.
    const produktseite = /\/products\//.test(location.pathname);
    if (!produktseite || !form || !formId || !echterKnopf || echterKnopf.disabled || !('IntersectionObserver' in window)) {
      aufraeumen();
      return;
    }

    const bar = leisteBauen();
    const preisFeld = document.querySelector('.price-row span');
    const preisEl = bar.querySelector('[data-kaufleiste-preis]');
    const knopfEl = bar.querySelector('[data-kaufleiste-knopf]');

    preisEl.textContent = preisFeld ? preisFeld.textContent.trim() : '';
    knopfEl.setAttribute('form', formId);
    knopfEl.textContent = echterKnopf.textContent.trim();
    knopfEl.disabled = echterKnopf.disabled;

    // Der Knopf selbst ist das Ziel, nicht die buy-row: eine hohe Zeile waere
    // bei threshold 1 nie vollstaendig im Bild und die Leiste bliebe kleben.
    const ziel = echterKnopf;
    if (beobachter) beobachter.disconnect();
    beobachter = new IntersectionObserver(eintraege => {
      const zeigen = !eintraege[0].isIntersecting;
      bar.classList.toggle('is-visible', zeigen);
      hoeheSetzen(zeigen ? bar.offsetHeight : 0);
    }, { threshold: 1, rootMargin: '0px 0px -88px 0px' });
    beobachter.observe(ziel);
  }

  /* Nach einem Variantenwechsel ersetzt zinke.js den Produktblock – Preis,
     Beschriftung und Verfuegbarkeit muessen neu uebernommen werden. */
  document.addEventListener('zinke:variant:change', einrichten);
  document.addEventListener('shopify:section:load', einrichten);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
})();
